@if (formGroup) {
    <form (ngSubmit)="saveConfiguration()" [formGroup]="formGroup" class="form-container">
        @if (isLoading) {
            <app-loading-indicator />
        }
        <div class="title-header">
            <span class="flex-1">{{ 'organisation.configuration' | translate }}</span>
            <button class="icon-button icon-close" mat-dialog-close="" type="button"></button>
        </div>
        <div class="scroll-container">
            <div class="content">
                <div class="form-section">
                    <div class="form-cell">
                        <sag-ui-date-range-picker
                            [formGroup]="formGroup"
                            formControlNameStart="reportStartDate"
                            formControlNameEnd="reportEndDate"
                            [label]="'organisation.settings.period' | translate"
                            [placeholder]="'MM/DD/YYYY - MM/DD/YYYY'"
                        />
                    </div>
                </div>
                <div class="form-section form-section--parent form-section--dark form-section--no-padding">
                    <div class="form-section-item">
                        <label>{{ 'organisation.settings.reportTemplate' | translate }}</label>
                        <div class="form-cell">
                            <reporting-tool-template-picker
                                (preview)="preview($event)"
                                (modify)="openTemplateEditor($event)"
                                [hoverable]="false"
                                [required]="true"
                                [editable]="isEditable"
                                [deletable]="!freezeDateReached"
                                [query]="{ orgCode: orgCode, responsibleType: responsibleType }"
                                formControlName="selectedTemplate"
                                placeholder="report.item.template"
                            ></reporting-tool-template-picker>
                        </div>
                    </div>
                    <div class="form-section-item">
                        <div class="form-cell freeze-date-container">
                            <sag-ui-input
                                class="datepicker"
                                formControlName="freezeDate"
                                type="date"
                                (dateChange)="onFreezeDateChange($event)"
                                [label]="'organisation.settings.freezeDate' | translate"
                                [placeholder]="'MM/DD/YYYY'"
                            />
                            <sag-ui-button [square]="true" [icon]="'circle-information'" (click)="openInfoModal()" />
                        </div>
                        <div class="form-cell label-checkbox">
                            @if (isOrgNode) {
                                <sag-ui-checkbox formControlName="inheritedTemplateFromParent">
                                    {{ 'organisation.settings.inheritTemplate' | translate }}
                                </sag-ui-checkbox>
                            }
                        </div>
                    </div>
                </div>
                <div class="form-section">
                    <div class="form-cell">
                        <sag-ui-input
                            class="datepicker"
                            formControlName="dueDate"
                            type="date"
                            (dateChange)="onDueDateChange($event)"
                            [label]="'organisation.settings.dueDate' | translate"
                            [placeholder]="'MM/DD/YYYY'"
                        />
                    </div>
                </div>
                @if (isOrgNode) {
                    <div class="form-section">
                        <div class="form-cell label-checkbox">
                            <sag-ui-checkbox formControlName="disableCascadingForChildren">
                                {{ 'organisation.settings.disableCascading' | translate }}
                            </sag-ui-checkbox>
                        </div>
                    </div>
                }
            </div>
        </div>
        <div class="form-button-container">
            <div class="left-container">
                <sag-ui-button type="button" icon="copy" (click)="inheritDates()">
                    {{ 'organisation.settings.inheritDates' | translate }}
                </sag-ui-button>
            </div>
            <div class="right-container">
                <sag-ui-button type="submit" icon="save">{{ 'default.buttons.save' | translate }}</sag-ui-button>
            </div>
        </div>
    </form>
}
